import { createSelector } from 'reselect';
import { initialState } from './render-controller.reducers';

const selectRenderController = (state: any) =>
  state.renderControllerReducer || initialState;

const makeSelectNotification = () =>
  createSelector(
    selectRenderController,
    renderControllerState => renderControllerState.notification,
  );

const makeSelectIsLoading = () =>
  createSelector(
    selectRenderController,
    renderControllerState => !!renderControllerState.isLoading,
  );

export { selectRenderController, makeSelectNotification, makeSelectIsLoading };
